<template>
  <div class="rate">
    <div class="rate-cycle">
      <div class="rate-cycle__title">给达人的结佣周期:</div>
      <span class="color-blue color-blue__underline" @click="onOpenDialog"
        >D+{{ curForm.ksCommissionDay }}
        {{ curForm.ksCommissionType === 0 ? "手动结佣" : "自动结佣" }}</span
      >
      <div class="rate-num" v-if="failCount">
        <img src="../../../../assets/img/tk/tip.png" />
        <div class="color-red">{{ failCount }}条</div>
        数据自动结佣失败，明天自动结佣时将会重新发起结佣，请保证
        <div class="link" @click="goPath">账号余额</div>
        充足。您也可以手动进行结佣，结佣成功后，自动结佣不会二次结佣。
      </div>
    </div>

    <el-dialog
      v-if="dialogVisible"
      width="800px"
      title="结佣周期设置"
      :visible.sync="dialogVisible"
      modal-append-to-body
      append-to-body
      @cancel="onCancel"
    >
      <el-form label-width="100px" :model="form" :rules="rules" ref="form">
        <div class="rate-flex">
          <el-form-item class="rate-left" label="结佣周期：" prop="ksCommissionDay">
            <div class="rate-flex">
              <div class="rate-left__day">D+</div>
              <el-input v-model="form.ksCommissionDay" placeholder="请输入"> </el-input>
            </div>
          </el-form-item>
          <div class="rate-tip">
            表示您与您底下分销达人约定按此周期进行佣金结算，此周期会展示给达人端。
            <div class="rate-tip__sub">
              例：结佣周期设为D+3，表示10号完成结算(放映2小时后订单完成结算)的订单，您需在13号结佣给达人。
            </div>
          </div>
        </div>
        <div class="rate-flex">
          <el-form-item class="rate-left" label="结佣方式：" prop="ksCommissionType">
            <el-radio-group v-model="form.ksCommissionType">
              <el-radio :label="0">手动结佣 </el-radio>
              <el-radio :label="1">自动结佣 </el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="rate-tip">
            <div>手动结佣：需要您手动发起结佣。</div>
            <div>
              自动结佣：开启自动结佣后，系统将按上方设置的结佣周期自动结佣给达人。佣金将从您余额中扣除。若结佣失败(系统会向您当前账号的手机号发送结佣失败短信通知)，下次结佣时会重新发起结佣。<span
                class="color-red"
                >(自动结佣今天开启明天才会生效)</span
              >
            </div>
            <div class="rate-tip__sub">
              例：若结佣周期设为D+3，13号开启自动结佣。则表示14号早上{{
                settleTime
              }}点前系统会将11号结算的订单进行自动结佣<span class="color-red"
                >(11号之前结算的订单不会自动结佣)</span
              >。若存在结佣失败数据，系统将在15号重新发起结佣。
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="warning" @click="onSure" :loading="saveLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
import { matchInteger } from "@/utils/regExp";

const DouYinModel = new douYin();
export default {
  props: {
    row: {
      // 行数据
      type: Object,
      default: () => {},
    },
    isBatch: {
      // 是否是批量操作
      type: Boolean,
      default: false,
    },
    ids: {
      // ids的集合
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      saveLoading: false,
      curForm: {
        ksCommissionType: "", // 结佣方式
        ksCommissionDay: "", // 结佣周期
      },
      form: {
        ksCommissionType: "", // 结佣方式
        ksCommissionDay: "", // 结佣周期
      },
      failCount: 0, // 结佣失败条数
      settleTime: "", // 结佣时间
      dialogVisible: false, // 显示弹框
      rules: {
        ksCommissionDay: [
          {
            required: true,
            message: "请输入结佣周期",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            pattern: matchInteger,
            message: "请输入正整数",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value > 30) {
                callback(new Error("请输入0~30之间的数值"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  mounted() {
    this.getDetail();
    this.getSettleFailCount();
  },
  methods: {
    // 前往充值
    goPath() {
      this.$router.push({
        path: "/pc/user/account",
        query: { recharge: true },
      });
    },
    // 打开弹框
    onOpenDialog() {
      this.form.ksCommissionType = this.curForm.ksCommissionType;
      this.form.ksCommissionDay = this.curForm.ksCommissionDay;
      this.dialogVisible = true;
    },
    // 取消
    onCancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },

    // 获取详情
    async getDetail() {
      const data = await DouYinModel.querySettleCommission();
      if (data.data.code !== 200) {
        this.$message.error(data.data.message);
      } else {
        this.curForm.ksCommissionType = data.data.data.ksCommissionType;
        this.curForm.ksCommissionDay = data.data.data.ksCommissionDay;
      }
    },
    // 获取失败条数
    async getSettleFailCount() {
      const data = await DouYinModel.querySettleFailCount({
        miniAppType: 5,
      });
      if (data.data.code !== 200) {
        this.$message.error(data.data.message);
      } else {
        this.failCount = data.data.data.failCount;
        this.settleTime = data.data.data.time;
      }
    },
    // 确定
    onSure() {
      this.saveLoading = true;
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = await DouYinModel.setKsSettleCommission({ ...this.form }).finally(
            () => {
              this.saveLoading = false;
            }
          );
          if (data.data.code !== 200) {
            this.$message.error(data.data.message);
          } else {
            this.onCancel();
            this.getDetail();
            this.getSettleFailCount();
            this.$emit("refresh");
            this.$message.success(data.data.message);
          }
        } else {
          this.saveLoading = false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form {
  .el-input {
    width: 213px;
  }
}

.rate {
  display: flex;
  align-items: center;
  margin-left: 20px;

  &-cycle {
    display: flex;
    align-items: center;

    i {
      margin-left: 10px;
    }

    &__title {
      margin-right: 10px;
    }
  }

  &-num {
    background: #fff6f8;
    border-radius: 2rpx;
    display: flex;
    align-items: center;
    padding: 10px;
    margin-left: 20px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }

    .link {
      color: #3d9efc;
      text-decoration: underline;
      margin: 0 2px;
      cursor: pointer;
    }
  }

  &-left {
    min-width: 350px;
    margin-right: 24px;
    margin-bottom: 0;

    &__day {
      margin-right: 10px;
    }
  }

  &-flex {
    display: flex;
    margin-bottom: 10px;
  }

  &-tip {
    background: #fafafa;
    padding: 8px;
    flex: 1;
    color: black;

    &__sub {
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/distribution/SetSettleCycle.vue